import React, { Fragment, useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Container,
  Grid2,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import "@fontsource/open-sans";
import "@fontsource/inter";
import Colors from "../../assets/styles";
import AuthServices from "../../apis/AuthServices";
import moment from "moment/moment";
import { Controller, useForm } from "react-hook-form";
import { ErrorToaster, SuccessToaster } from "../../components/toaster";
import { useNavigate } from "react-router-dom";

const Grid = (props) => <Grid2 {...props} />;

function Dashboard() {
  const [analytics, setAnalytics] = useState({});
  const [trains, setTrains] = useState([]);
  const [stations, setStations] = useState([]);
  const [locomotives, setLocomotives] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();

  // console.log(locomotives)
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      trainName: "",
      allocatedDate: moment().format("YYYY-MM-DD"),
      stationName: "",
      locomotive: "",
    },
  });

  const line1Cards = [
    {
      name: "Total Locomotives",
      number: analytics?.TotalCount,
    },
    {
      name: "Allocated",
      number: analytics?.Allocated,
    },
    {
      name: "Remaining ",
      number: analytics?.Remaining,
    },
  ];
  const dateOptions = [
    moment().format("YYYY-MM-DD"),
    moment().subtract(1, "days").format("YYYY-MM-DD"),
  ];

  const getAnalytics = async () => {
    try {
      const result = await AuthServices.getAnalytics();
      if (result.IsSuccess == true) {
        setAnalytics(result.Response);
      }
    } catch (error) {
      // console.log(error);
    }
  };

  const getTrains = async () => {
    try {
      const result = await AuthServices.getTrains();
      if (result.IsSuccess == true) {
        setTrains(result.Response);
      }
    } catch (error) {
      // console.log(error);
    }
  };
  const getTrainById = async (id) => {
    try {
      const result = await AuthServices.getTrainsById(id);
      // console.log(result);
      if (result.IsSuccess == true) {
        setStations(result.Response);
      }
    } catch (error) {
      // console.log(error);
    }
  };
  const getLocomotive = async () => {
    try {
      const result = await AuthServices.getLocomotive();
      // console.log(result);
      if (result.IsSuccess == true) {
        setLocomotives(result.Response);
      }
    } catch (error) {
      // console.log(error);
    }
  };
  useEffect(() => {
    getAnalytics();
    getTrains();
    getLocomotive();
  }, []);

  const handleChange = (event) => {
    getTrainById(event);
  };

  // const onSubmit = async(data) => {
  //   const obj = {
  //     StationId: data.stationName,
  //     TrainId: data.trainName,
  //     LocomotiveNumber: data.locomotive,
  //     AllocatedDate: data.allocatedDate,
  //     Remarks: "Originated",
  //     RideStatusId: 2,
  //   };

  //   try {
  //     const result = await AuthServices.allocateLocomotive(obj);
  //     if (result.IsSuccess == true) {
  //       SuccessToaster("Allocated")
  //       navigate("/live-trains")
  //     }
  //     else{
  //       ErrorToaster("Something went Wrong")
  //     }
  //   } catch (error) {
  //     ErrorToaster(error);
  //   }
  // };

  const onSubmit = async (data) => {
    setIsSubmitting(true);

    const obj = {
      StationId: data.stationName,
      TrainId: data.trainName,
      LocomotiveNumber: data.locomotive,
      AllocatedDate: data.allocatedDate,
      Remarks: "Originated",
      RideStatusId: 2,
    };

    try {
      const result = await AuthServices.allocateLocomotive(obj);
      if (result.IsSuccess) {
        SuccessToaster("Allocated");
        navigate("/allocation-list");
      } else {
        ErrorToaster("Something went Wrong");
      }
      
    } catch (error) {
      ErrorToaster(error);
    }finally{
      setIsSubmitting(false);
    }
  };

  return (
    <Fragment>
      <Grid container rowGap={3}>
        <Grid size={12}>
          <Typography
            sx={{
              fontSize: "1.51rem",
              fontWeight: 500,
              fontFamily: "Open Sans",
              color: Colors.primary,
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
            locomotive Allocation
          </Typography>
        </Grid>
        <Grid size={12}>
          <Box
            sx={{
              height: "calc(100vh - 237px)",
              overflowY: "scroll",
              "::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <Grid container rowGap={3}>
              <Grid size={12}>
                <Grid container spacing={2}>
                  {line1Cards.map((item, ind) => (
                    <Grid key={ind} size={{ xs: 12, sm: 6, md: 4 }}>
                      <Box
                        sx={{
                          p: 3,
                          display: "flex",
                          flexDirection: "column",
                          boxShadow: "0px 8px 24px 0 #4545501A",
                          backgroundColor: Colors.white,
                          borderRadius: "12px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            margin: " 0 auto",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontFamily: "Open Sans",
                              fontSize: "17px",
                              color: "#404e67",
                            }}
                          >
                            {item.name}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            margin: " 0 auto",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "28px",
                              fontWeight: 500,
                              fontFamily: "Open Sans",
                              lineHeight: "40px",
                              color: "#404e67",
                            }}
                          >
                            {item.number}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              <Grid size={12}>
                <Container
                  maxWidth="xl"
                  sx={{
                    mt: 2,
                    boxShadow: "0px 8px 24px 0 #4545501A",
                    py: 2,
                    backgroundColor: Colors.white,
                    borderRadius: "12px",
                  }}
                >
                  <Box sx={{ mb: 3 }}>
                    <Typography
                      variant="h6"
                      component="h1"
                      sx={{ color: "#404e67" }}
                    >
                      LOCOMOTIVE ALLOCATION
                    </Typography>
                  </Box>

                  <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 2,
                        flexDirection: { xs: "column", md: "row" },
                        mb: 3,
                      }}
                    >
                      <Box sx={{ width: "100%" }}>
                        <Typography
                          variant="body2"
                          sx={{ mb: 1, color: "#404e67" }}
                        >
                          Train Name
                        </Typography>
                        <Controller
                          name="trainName"
                          control={control}
                          rules={{ required: "Train Name is required" }}
                          render={({ field }) => (
                            <Autocomplete
                              {...field}
                              options={trains}
                              getOptionLabel={(option) =>
                                option?.TrainName || ""
                              }
                              isOptionEqualToValue={(option, value) =>
                                option?.TrainId === value
                              }
                              value={
                                trains?.find(
                                  (train) => train.TrainId === field.value
                                ) || null
                              }
                              onChange={(_, value) => {
                                field.onChange(value?.TrainId || "");
                                handleChange(value?.TrainId || "");
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  error={!!errors.trainName}
                                  helperText={errors.trainName?.message}
                                />
                              )}
                            />
                          )}
                        />
                      </Box>
                      <Box sx={{ width: "100%" }}>
                        <Typography
                          variant="body2"
                          sx={{ mb: 1, color: "#404e67" }}
                        >
                          Allocated Date
                        </Typography>
                        <Controller
                          name="allocatedDate"
                          control={control}
                          rules={{ required: "Allocated Date is required" }}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              select
                              fullWidth
                              error={!!errors.allocatedDate}
                              helperText={errors.allocatedDate?.message}
                            >
                              {dateOptions.map((date, index) => (
                                <MenuItem key={index} value={date}>
                                  {moment(date).format("MMMM D, YYYY")}
                                </MenuItem>
                              ))}
                            </TextField>
                          )}
                        />
                      </Box>
                      <Box sx={{ width: "100%" }}>
                        <Typography
                          variant="body2"
                          sx={{ mb: 1, color: "#404e67" }}
                        >
                          Station Name
                        </Typography>
                        <Controller
                          name="stationName"
                          control={control}
                          rules={{ required: "Station Name is required" }}
                          render={({ field }) => (
                            <Autocomplete
                              {...field}
                              options={stations}
                              getOptionLabel={(option) =>
                                option?.StationName || ""
                              }
                              isOptionEqualToValue={(option, value) =>
                                option?.StationDetailsId === value
                              }
                              value={
                                stations?.find(
                                  (station) =>
                                    station.StationDetailsId === field.value
                                ) || null
                              }
                              onChange={(_, value) =>
                                field.onChange(value?.StationDetailsId || "")
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  error={!!errors.stationName}
                                  helperText={errors.stationName?.message}
                                />
                              )}
                            />
                          )}
                        />
                      </Box>
                      <Box sx={{ width: "100%" }}>
                        <Typography
                          variant="body2"
                          sx={{ mb: 1, color: "#404e67" }}
                        >
                          Locomotive
                        </Typography>
                        <Controller
                          name="locomotive"
                          control={control}
                          rules={{ required: "Locomotive is required" }}
                          render={({ field }) => (
                            <Autocomplete
                              {...field}
                              options={locomotives}
                              getOptionLabel={(option) =>
                                option?.LocomotiveNumber || ""
                              }
                              isOptionEqualToValue={(option, value) =>
                                option?.LocomotiveNumber == value
                              }
                              value={
                                locomotives?.find(
                                  (loco) => loco.LocomotiveNumber == field.value
                                ) || null
                              }
                              onChange={(_, value) =>
                                field.onChange(value?.LocomotiveNumber || "")
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  error={!!errors.locomotive}
                                  helperText={errors.locomotive?.message}
                                />
                              )}
                            />
                          )}
                        />
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                      <Button
                        type="submit"
                        variant="contained"
                        disabled={isSubmitting} 
                        sx={{
                          bgcolor: "rgb(19 62 2)",
                          px:5,
                          py:1,
                          "&:hover": {
                            bgcolor: "rgb(19 62 2)",
                          },
                        }}
                      >
                        {isSubmitting ? <CircularProgress size={20} sx={{color:"green" }}/> : "Submit"}
                      </Button>
                    </Box>
                    
                  </Box>
                </Container>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default Dashboard;
